import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualCreditNotePage } from './manual-credit-note.page';

const routes: Routes = [
  {
    path: '',
    component: ManualCreditNotePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualCreditNotePageRoutingModule {}
